import { parse } from 'querystring';
import { match } from 'path-to-regexp';

/* eslint no-useless-escape:0 import/prefer-default-export:0 */
const reg = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/;

export const isUrl = (path: string): boolean => reg.test(path);

export const isAntDesignPro = (): boolean => {
  if (ANT_DESIGN_PRO_ONLY_DO_NOT_USE_IN_YOUR_PRODUCTION === 'site') {
    return true;
  }
  return window.location.hostname === 'preview.pro.ant.design';
};

// 给官方演示站点用，用于关闭真实开发环境不需要使用的特性
export const isAntDesignProOrDev = (): boolean => {
  const { NODE_ENV } = process.env;
  if (NODE_ENV === 'development') {
    return true;
  }
  return isAntDesignPro();
};

export const getPageQuery = () => parse(window.location.href.split('?')[1]);

export const getAuthorityFromRouter = <T extends { path: string }>(
  router: T[] = [],
  pathname: string,
): T | undefined => {
  const authority = router.find(({ path }) => path && match(path)(pathname));
  if (authority) return authority;
  return undefined;
};

export const filterDataSource = (filterFields: any, params: any, dataSource: any) => {
  const paramKeys = Object.keys(params);
  filterFields.map((item: any) => {
    if (paramKeys.includes(item.key) && params[item.key]) {
      dataSource = dataSource.filter((data: any) => {
        if (item.type === 'boolean') {
          if (params[item.key] == 'true') {
            return data[item.key];
          }
          return !data[item.key];
        } else {
          return data[item.key] == params[item.key];
        }
      });
    }
  });
  return dataSource;
};

export const getRandomNumber = (minimum: number, maximum: number) => {
  return Math.floor(Math.random() * (maximum - minimum + 1)) + minimum;
};
